import { h } from "preact";
import RedirectUrl from "../../components/RedirectUrl";


export default function DocumentationPage(props) {

    return <RedirectUrl url={"https://docs.services.verigram.cloud"} />
}